import React from 'react';
import get from 'lodash/get';
import { Typography } from 'antd';
import moment from 'moment';

const { Text } = Typography;
export const e = 5;

export const orderDescription = ({ toggleModal }) => [
  {
    title: 'Sales Type',
    key: 'is_sample',
    dataIndex: 'is_sample',
    render: (item) => <Text>{item ? 'Sample Sale' : 'Retail Sale'}</Text>,
  },
  {
    title: 'Brand',
    key: 'brand',
    dataIndex: ['CompanySalesChannel', 'Company', 'name'],
  },
  {
    title: 'Order No.',
    key: 'order_no',
    dataIndex: 'order_no',
  },
  {
    title: 'SKU',
    key: 'sku',
    dataIndex: ['OrderProducts', '0', 'Product', 'dhandha_sku'],
  },
  {
    title: 'Customer ID',
    key: 'customer_code',
    dataIndex: ['OrderCustomer', 'code'],
    render: (item, record) => (
      <Text
        className="text-theme-color"
        onClick={() => {
          toggleModal(get(record, 'OrderCustomer'));
        }}
        underline
      >
        {item || '--'}
      </Text>
    ),
  },
  {
    title: 'Channel',
    key: 'channel',
    dataIndex: ['CompanySalesChannel', 'SalesChannel', 'name'],
  },
  {
    title: 'Amount',
    key: 'amount',
    dataIndex: 'amount',
  },
  {
    title: 'Retailer',
    key: 'retailer',
    dataIndex: ['PartnerRetailer', 'name'],
  },
  {
    title: 'Touchpoint',
    key: 'touch_point',
    render: () => <Text>--</Text>,
  },
  {
    title: 'Order Date',
    key: 'order_date',
    dataIndex: 'created_at',
    render: (item) => (
      <Text>{moment(item).format('DD/MM/YYYY (hh:mm A)')}</Text>
    ),
  },
];
